// Used by: ContractSigned, PaymentSuccess
const Timeline = ({ children }) => {
    return <div className="timeline">{children}</div>;
};

export default Timeline;
